import AnimatedCount from '../../../assets/js/_animated-count.js';

// gets the inner-most node to animate so we can use the rich text formatter
export default Array.from( document.querySelectorAll( '.animated-number' ) ).map( node => {
	let duration = node.dataset.duration;
	let format   = node.dataset.format;

	while ( node && node.children && node.children.length ) {
		node = node.children[0];
	}

	if ( node.innerText.match(/[^\d,]/) ) {
		return null;
	}

	return new AnimatedCount( node, duration, format );
} ).filter( v => v );
